import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    PlannedConsultationEditor: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2rem',
    },
    PlannedConsultationEditorLoader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '2rem',
        minHeight: '60vh',
    },
    PlannedConsultationEditorContainer: {
        width: '100%',
        padding: '2.5rem',
        background: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
    },
    PlannedConsultationEditorTokTokDocForm: {
        width: '100%',
        '& .MuiPaper-root': {
            background: 'transparent !important',
            padding: '0 !important',
        },
        '& .MuiPaper-root.MuiCard-root': {
            overflow: 'visible',
        },
    },
    PlannedConsultationEditorFormContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2rem',
    },
    PlannedConsultationEditorForm: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2.5rem',
    },
    PlannedConsultationEditorFormError: {
        width: '100%',
        padding: '.8rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.red.ultraLight,
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.red.main,
        borderRadius: '9px',
    },
    PlannedConsultationEditorFormRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2.5rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            gap: '1.5rem',
        },
    },
    PlannedConsultationEditorFormItem: {
        width: '100%',
    },
    PlannedConsultationEditorFormField: {
        width: '100%',
        '& fieldset': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            border: `2px solid ${theme.palette.lightGrey.medium}`,
            borderRadius: '9px',
        },
        '& .MuiFormLabel-root': {
            fontWeight: 600,
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: `${theme.palette.typography.light} !important`,
        },
        '& .MuiInputBase-input': {
            fontWeight: 600,
        },
        '& .MuiFormLabel-root.Mui-focused': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: `${theme.palette.typography.light} !important`,
        },
        '& .Mui-focused fieldset': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            borderColor: `${theme.palette.typography.main} !important`,
        },
        '& .MuiAutocomplete-input': {
            fontWeight: 600,
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: `${theme.palette.typography.main} !important`,
        },
    },
    PlannedConsultationEditorFormFieldDisabled: {
        '& fieldset': {
            borderColor: 'transparent !important',
            borderRadius: '9px',
        },
        '& .Mui-focused fieldset': {
            borderColor: 'transparent !important',
        },
        '& .MuiInputBase-root': {
            paddingLeft: 0,
            paddingRight: 0,
        },
        '& .MuiInputBase-input': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
        },
        '& .MuiFormLabel-root': {
            left: '-14px',
        },
        '& .MuiAutocomplete-input': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: `${theme.palette.typography.main} !important`,
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            '-webkit-text-fill-color': `${theme.palette.typography.main} !important`,
        },
    },
    PlannedConsultationEditorContainerHeader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1.5rem',
    },
    PlannedConsultationEditorContainerHeaderButtonContainer: {},
    PlannedConsultationEditorContainerHeaderTitle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.5rem',
    },
    PlannedConsultationEditorContainerTitle: {
        fontSize: '1.6rem',
        fontWeight: 700,
    },
    PlannedConsultationEditorContainerSubtitle: {
        fontSize: '.9rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
    PlannedConsultationEditorMediaList: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.5rem',
    },
    PlannedConsultationEditorMediaListLoader: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        inset: 0,
        background: 'rgba(255,255,255,0.7)',
        zIndex: 300,
    },
    PlannedConsultationEditorMediaListHintContainer: {
        width: '100%',
        minHeight: '30rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    PlannedConsultationEditorMediaListContent: {},
    PlannedConsultationEditorMediaListDropzoneContainer: {
        width: '100%',
        color: 'rgba(0, 0, 0, 0.87)',
        padding: 0,
    },
    PlannedConsultationEditorMediaListDropzone: {
        width: '100%',
        color: 'rgba(0, 0, 0, 0.87)',
        padding: '2.5rem',
        borderRadius: '12px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `4px dashed ${theme.palette.lightGrey.half}`,
        minHeight: '30rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    PlannedConsultationEditorMediaListContentContainers: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '2.5rem',
    },
    PlannedConsultationEditorMediaListContentContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1rem',
    },
    PlannedConsultationEditorMediaListContentContainerLabel: {
        fontSize: '1.3rem',
    },
    PlannedConsultationEditorMediaListContentContainerList: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '1rem',
    },
    PlannedConsultationEditorFormMedia: {
        width: '12rem',
    },
    PlannedConsultationEditorFormMediaCard: {
        width: '100%',
        background: '#ffffff',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `1px solid ${theme.palette.lightGrey.medium}`,
        borderRadius: '9px',
        marginBottom: '.7rem',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
    },
    PlannedConsultationEditorFormMediaThumbnailContainer: {
        height: '10rem',
        overflow: 'hidden',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 0,
        borderRadius: 0,
    },
    PlannedConsultationEditorFormMediaThumbnail: {
        height: '100%',
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        backgroundColor: theme.palette.lightGrey.half,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all .13s ease-in-out',
        opacity: '1',
        '&:hover': {
            transform: 'scale(1.1)',
            opacity: '.7',
        },
    },
    PlannedConsultationEditorFormMediaThumbnailPdf: {
        width: '5rem',
        height: '5rem',
        background: '#ffffff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '100px',
    },
    PlannedConsultationEditorFormMediaThumbnailPdfText: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '.9rem',
        fontWeight: 800,
    },
    PlannedConsultationEditorFormMediaBanner: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '.5rem',
        padding: '.5rem',
    },
    PlannedConsultationEditorFormMediaBannerButton: {
        minWidth: 0,
        minHeight: 0,
        padding: '.4rem',
        background: '#ffffff',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `2px solid ${theme.palette.lightGrey.medium}`,
        borderRadius: '9px',
        '& *': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: theme.palette.typography.main,
            fontSize: '1.2rem',
        },
    },
    PlannedConsultationEditorFormMediaName: {},
    PlannedConsultationEditorMediaViewerEditionButton: {
        '& *': {
            color: '#ffffff',
        },
    },
    PlannedConsultationEditorDocumentViewer: {
        height: '100vh',
        width: '100%',
    },
}))
